// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__309rb","list":"PatternAutocomplete_list__15q9E"};